import React from "react";

import { Spin as AntSpin, SpinProps as AntSpinProps } from "antd";

import { Icon } from "components";

type SpinProps = AntSpinProps & {
  dataTestId?: string;
  iconName?: string;
  color?: string;
};
export const Spin = ({ dataTestId, size = "large", color = "#065c45", style, iconName = "tabler/circle-dashed", ...props }: SpinProps) => (
  <AntSpin
    indicator={<Icon dataTestId={dataTestId} iconName={iconName} className="anticon-spin" alt="spinner" />}
    size={size}
    style={{ ...{ color: color }, ...style }}
    {...props}
  />
);

export default Spin;
